import { Route } from 'react-router-dom';
import ManualIndexPage from '../../pages/manual/manual.index';
import ManualSectionPage from '../../pages/manual/manual.section';

/** Manual de uso. Sin guard de permisos: cualquier rol autenticado lo lee. */
export const RaptorManualRoutes = (
  <Route path="/manual">
    <Route index element={<ManualIndexPage />} />
    <Route path=":slug" element={<ManualSectionPage />} />
  </Route>
);
